import React, { useMemo } from 'react';
import { Link, useLocation } from 'react-router-dom';

const prettyFeature = (feature) => {
  const value = String(feature || '').trim();
  if (!value) {
    return 'This feature';
  }
  if (value === 'wallet_topup' || value === 'add_funds') {
    return 'Wallet top-ups';
  }
  if (value === 'buy_credits' || value === 'trade_buy') {
    return 'Buying credits';
  }
  if (value === 'list_credits' || value === 'trade_sell') {
    return 'Listing credits';
  }
  if (value === 'swap' || value === 'trade_swap') {
    return 'Swaps';
  }
  if (value === 'surrender' || value === 'epa_surrender') {
    return 'Compliance surrender';
  }
  return value.replace(/[_-]+/g, ' ');
};

export default function ComingSoon() {
  const location = useLocation();

  const feature = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return prettyFeature(params.get('feature'));
  }, [location.search]);

  return (
    <div className="page-shell page-stack">
      <section className="surface-panel glow-surface" style={{ padding: '1.8rem' }}>
        <div className="section-stack">
          <div className="section-tag">Coming soon</div>
          <h1 className="section-title">{feature} isn&apos;t available yet</h1>
          <p className="section-copy" style={{ maxWidth: '760px' }}>
            We&apos;re building this carefully—payments, settlement, and compliance-grade audit trails take time to do right.
            Please check back later.
          </p>
          <div className="hero-note" style={{ marginTop: '1rem' }}>
            <div className="info-chip">Safety first</div>
            <div className="info-chip">Production-ready flows</div>
            <div className="info-chip">Worth the wait</div>
          </div>
          <div className="inline-actions" style={{ marginTop: '1.4rem' }}>
            <Link to="/dashboard" className="btn btn-primary">Back to dashboard</Link>
            <Link to="/listings" className="btn btn-secondary">Browse marketplace</Link>
            <Link to="/trade" className="btn btn-secondary">Open trade desk</Link>
          </div>
        </div>
      </section>
    </div>
  );
}
